$('document').ready(function () {

	// Hamburger
	$('.mobile-menu-button').click(function () {
		$('#primary_mega_menu').toggleClass('show');
		$('body').toggleClass('menu-active');
		$(this).toggleClass('active');
		const expanded = $(this).attr('aria-expanded') === 'true';
		$(this).attr('aria-expanded', !expanded);
	});

	// Team bios
	$('html').on('click', '.team-target', function (event) {
		event.preventDefault();

		$('.team-target').addClass('fade');
		$(this).removeClass('fade');

		$(this).parentsUntil('list-blocks-slider').next('.team-bio').find('> div').fadeOut();
		var target_member = $(this).attr('ID');
		$(this).parentsUntil('list-blocks-slider').next('.team-bio').find('> div#' + target_member).fadeIn();

		$('html, body').animate({
			scrollTop: $(this).parentsUntil('list-blocks-slider').next('.team-bio').offset().top - 140
		}, 700);
	});

	$('html').on('click', '.close-btn', function (event) {
		event.preventDefault();
		$('.team-target').removeClass('fade');
		$('.team-bio > div').fadeOut();
	});

	// Industries anchor
	if (window.location.hash) {
		var target = window.location.hash;
		if ($(target).length != 0) {
			$('html, body').animate({
				'scrollTop': $(target).offset().top - 100
			}, 1);
		}
	}

	$('.accordion-toggle').click(function () {
		var $item = $(this).closest('.accordion-item');

		// Close others
		$('.accordion-item').not($item).removeClass('active').find('.accordion-content').slideUp();

		// Toggle current
		$item.toggleClass('active');
		$item.find('.accordion-content').slideToggle();
	});
});

let ticking = false;

function updateScrollState() {
	document.body.classList.toggle("is-scrolled", window.scrollY > 50);
}

window.addEventListener("scroll", () => {
	if (!ticking) {
		window.requestAnimationFrame(() => {
			updateScrollState();
			ticking = false;
		});
		ticking = true;
	}
});

// run once on load
window.addEventListener("load", updateScrollState);

const gatedDownloadWindows = new WeakMap();

document.addEventListener("submit", (event) => {
	const form = event.target.closest(".wpcf7-form");
	const download = form && form.querySelector('input[name="_gated_download"]');

	if (!download || !download.value) return;

	const previousWindow = gatedDownloadWindows.get(form);
	if (previousWindow && !previousWindow.closed) previousWindow.close();

	const downloadWindow = window.open("", "_blank");
	if (downloadWindow) {
		downloadWindow.opener = null;
		gatedDownloadWindows.set(form, downloadWindow);
	}
}, true);

document.addEventListener("wpcf7mailsent", (event) => {
	const form = event.target;
	const download = form.querySelector('input[name="_gated_download"]');
	const downloadWindow = gatedDownloadWindows.get(form);

	if (!download || !download.value) return;

	if (downloadWindow && !downloadWindow.closed) {
		downloadWindow.location.replace(download.value);
	} else {
		window.open(download.value, "_blank", "noopener");
	}

	gatedDownloadWindows.delete(form);
});

["wpcf7invalid", "wpcf7unaccepted", "wpcf7spam", "wpcf7aborted", "wpcf7mailfailed", "wpcf7payment-required"].forEach((eventName) => {
	document.addEventListener(eventName, (event) => {
		const downloadWindow = gatedDownloadWindows.get(event.target);
		if (downloadWindow && !downloadWindow.closed) downloadWindow.close();
		gatedDownloadWindows.delete(event.target);
	});
});
